module.exports = __webpack_public_path__ + "static/media/txt.d37b8e81.svg";